import Component from '@glimmer/component';
import { t } from 'ember-intl';
import TioFaqs from 'tio-common/components/tio/faqs';
import SectionPanel from 'tio-ui/components/section-panel';
import { PhChatsCircle } from 'ember-phosphor-icons';
import type { MatchPlanFaq } from 'tio-data/data/resources/match-plan.type';

type SyfFaqsSignature = {
  Args: {
    faqs: MatchPlanFaq[];
  };
};

class SyfFaqsComponent extends Component<SyfFaqsSignature> {
  get orderedFaqs(): Array<MatchPlanFaq> {
    return this.args.faqs.sort((a, b) => a.ordinal - b.ordinal);
  }

  <template>
    <SectionPanel
      @icon={{PhChatsCircle}}
      @iconColor="blue"
      @headingLevel={{2}}
      @title={{t "tuition_assistance.faq"}}
    >
      <:body>
        {{#each this.orderedFaqs as |faq|}}
          <TioFaqs @question={{faq.heading}} @answer={{faq.body}} />
        {{/each}}
      </:body>
    </SectionPanel>
  </template>
}

export default SyfFaqsComponent;
